export const devConfigs = {
    serverUrl: process.env.REACT_APP_DEV_SERVER_URL,
    fileServer: process.env.REACT_APP_DEV_FILE_SERVER_URL
}